module.exports = __webpack_public_path__ + "static/media/eddysuarez.e4b4f9af.jpg";